export default "__VITE_ASSET__Byfc_H8D__"